import { TranslatePipe } from "@ngx-translate/core";

import { ChangeDetectionStrategy, Component, inject, input, output } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSortModule, Sort } from "@angular/material/sort";

import { AirtScanEdge, PageInfo } from "../../../apis/networkdashboard/graphql/graphql";
import { Pagination } from "../../common/pagination/pagination";
import { DialogCert } from "../../dialogs/dialog-cert/dialog-cert";

@Component({
  selector: "cert-table",
  templateUrl: "cert-table.html",
  styleUrl: "cert-table.scss",
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [MatSortModule, Pagination, TranslatePipe],
})
export class CertTable {
  private dialog = inject(MatDialog);
  securityScans = input.required<AirtScanEdge[]>();
  pageInfo = input.required<PageInfo>();
  paginationChanged = output<number>();
  sortingChanged = output<Sort>();

  protected onPaginationChanged($event: number) {
    this.paginationChanged.emit($event);
  }

  protected openDialog(item: AirtScanEdge) {
    this.dialog.open(DialogCert, {
      data: item.node,
    });
  }

  protected sortData($event: Sort) {
    this.sortingChanged.emit($event);
  }
}
